// Capelli — descripción de producto: convierte <h3>+<ul> del body_html en
// acordeones estilo Capelli (.cap-acc). Los productos que ya traen .cap-accordions
// horneado (p. ej. el piloto) se respetan sin tocar.
(function () {
  var LABELS = { 'Cuidados': 'Instrucciones de cuidado' };

  function findDescFormatter() {
    var fmts = document.querySelectorAll('rte-formatter, .rte');
    for (var i = 0; i < fmts.length; i++) {
      var f = fmts[i];
      if (f.querySelector('.cap-accordions')) continue; // ya transformado
      var h3s = f.querySelectorAll(':scope > h3');
      for (var j = 0; j < h3s.length; j++) {
        if (/Caracter|Materiales|Cuidado|Instruccion/i.test(h3s[j].textContent)) return f;
      }
    }
    return null;
  }

  function transform() {
    var fmt = findDescFormatter();
    if (!fmt) return;
    var kids = Array.prototype.slice.call(fmt.children);
    var intro = [], sections = [], cur = null;
    kids.forEach(function (el) {
      if (el.tagName === 'H3') { cur = { t: el.textContent.trim(), b: '' }; sections.push(cur); }
      else if (cur) { cur.b += el.outerHTML; }
      else { intro.push(el.outerHTML); }
    });
    if (!sections.length) return;
    var html = '<h4 class="cap-desc-title">Descripción del producto</h4>';
    html += '<div class="cap-desc-text">' + intro.join('') + '</div>';
    html += '<div class="cap-accordions">';
    sections.forEach(function (s) {
      var label = LABELS[s.t] || s.t;
      html += '<details class="cap-acc"><summary>' + label + '</summary><div class="cap-acc-body">' + s.b + '</div></details>';
    });
    if (document.querySelector('input[data-option-name="Talla"]')) {
      html += '<details class="cap-acc"><summary>Guía de tallas</summary><div class="cap-acc-body"><p>Consulta nuestra tabla de tallas para elegir el calce correcto.</p></div></details>';
    }
    html += '</div>';
    fmt.innerHTML = html;
  }

  // Anti-FOUC: capelli-description.css vela la descripción con secciones <h3>
  // (que se pintaría cruda en Saira 32px) hasta que #MainContent tenga la clase
  // 'cap-desc-ready'. La agregamos SIEMPRE tras intentar transformar (haya o no
  // secciones) para que nada quede oculto de forma permanente.
  function markReady() {
    var m = document.getElementById('MainContent');
    if (m) m.classList.add('cap-desc-ready');
  }

  function initDesc() { try { transform(); } catch (e) {} markReady(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDesc);
  else initDesc();

  // Re-ejecutar tras navegaciones con view-transition o recargas de sección.
  var mainEl = document.querySelector('#MainContent') || document.body;
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () { scheduled = false; initDesc(); });
  }).observe(mainEl, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', initDesc);
})();
